import styled from 'styled-components'

const RadioBox = styled.label`
  display: inline-block;
  position: relative;
  cursor: pointer;
  font-size: 12px;
  user-select: none;
  padding-left: 18px;

  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;

    :checked ~ .checkmark {
      background-color: #12161c;
      border: 1px solid #f0b90b;
    }

    :checked ~ .checkmark:after {
      display: block;
    }
  }

  .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 12px;
    width: 12px;
    background-color: #12161c;
    border-radius: 50%;
    border: 1px solid #848e9c;

    :after {
      content: '';
      position: absolute;
      display: none;

      top: 2px;
      left: 2px;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background: #f0b90b;
    }
  }
`

export default function Radio ({
  onChange,
  name = 'radio',
  text,
  value,
  checked = false,
  className = '',
  style = {}
}) {
  return (
    <RadioBox className={className} style={style}>
      {text}
      <input type="radio" name={name} value={value} checked={checked} onChange={onChange} />
      <span className="checkmark" />
    </RadioBox>
  )
}
